import React, { useState, useEffect, useCallback } from 'react';
import RModal from '../../../../components/Rsuite/Modal';
import api from '../../../../services/api';
import { CustomButton } from '../../../../components/CustomButton';
import { Item } from './Item';
import { useAuth } from '../../../../hooks/auth';
import { CustomCheckPicker } from '../../../../components/CustomCheckPicker';

import * as S from './styles';
import { Message, toaster } from 'rsuite';

export function AddProducts({ open, onClose, montagem, product }) {
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [selectedsIds, setSelectedsIds] = useState([]);
  const { id_empresa } = useAuth();

  const selectedProducts = products.filter((_product) =>
    selectedsIds.includes(_product.Id),
  );

  const selectData = products.map((_product) => ({
    value: _product.Id,
    label: _product.Descricao,
  }));

  const handleSave = async () => {
    try {
      const newData = {
        IdEmpresa: id_empresa,
        IdMontagem: montagem.Id,
        IdProduto: product.Id,
        Ativo: true,
        IdProdutos: selectedsIds,
      };

      const res = await api.post('/montagem-produtos/criar', newData);

      if (res.status !== 201) {
        throw new Error();
      }

      onClose();
      toaster.push(
        <Message showIcon type="success">
          Produtos salvos com sucesso.
        </Message>,
      );
    } catch (error) {
      console.log(error);
      getSelectedIds();
      toaster.push(
        <Message showIcon type="error">
          Não foi possivel salvar produtos da montagem.
        </Message>,
      );
    }
  };

  const getSelectedIds = useCallback(() => {
    api
      .get(`/montagem-produtos/listar/${montagem?.Id}`)
      .then((res) => {
        const _productIds = res.data?.map((_montagem) => _montagem.IdProduto);
        setSelectedsIds(_productIds);
      })
      .catch((err) => console.log(err));
  }, [montagem]);

  const handleCloseModal = () => {
    getSelectedIds();
    onClose();
  };

  useEffect(() => {
    api
      .get(`/produto/listarProdutosParaMontagem/${id_empresa}`)
      .then((res) => {
        const _products =
          res?.data?.filter((prod) => prod.Id !== product?.Id) ?? [];

        setProducts(_products);
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    if (montagem?.Id) {
      getSelectedIds();
    }
  }, [montagem]);

  return (
    <RModal
      open={open}
      onClose={handleCloseModal}
      title="Selecionar Produtos"
      footer={
        <CustomButton
          onClick={handleSave}
          disabled={isLoading}
          style={{ marginTop: '10px' }}
        >
          Salvar
        </CustomButton>
      }
    >
      <S.Container>
        <S.PickerWrapper>
          <CustomCheckPicker
            data={selectData}
            style={{ width: '100%' }}
            onChange={setSelectedsIds}
            value={selectedsIds}
          />
        </S.PickerWrapper>
        <S.ItemsContainer>
          {selectedProducts.map((_product) => (
            <Item
              key={_product.Id}
              product={_product}
              selected={selectedsIds.includes(_product.Id)}
              setSelectedsIds={setSelectedsIds}
            />
          ))}
        </S.ItemsContainer>
      </S.Container>
    </RModal>
  );
}
